<template>
  <div class="mt-2">
    <v-card flat color="#57bc90" style="min-height: 70vh">
      <v-row class="mx-1">
        <v-col cols="12" md="4" sm="12" class="mt-3">
          <v-expansion-panels focusable accordion v-model="panel">
            <v-expansion-panel v-model="panel">
              <v-expansion-panel-header class="text-sm-subtitle-2">
                Player Information
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Team Name:
                        <p class="body-2" style="vertical-align: middle">
                          {{ profile.teamCity }}
                          {{ profile.teamName }}( {{ profile.key }})
                        </p>
                      </v-list-item-title>

                      <v-list-item-title>
                        Team City:
                        <p class="body-2 green--text">
                          {{ profile.teamCity }}
                        </p>
                      </v-list-item-title>

                      <v-list-item-title>
                        Upcoming Game:
                        <p class="body-2 blue--text">
                          {{ profile.nextGame }} Vs.
                          {{ profile.oppName }}
                          <img
                            :src="profile.oppLogo"
                            alt="teamlogo"
                            height="35"
                            width="35"
                            style="vertical-align: middle"
                          />
                        </p>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- card 1 -->
        <v-col cols="12" md="4" sm="12">
          <v-card class="mx-auto mt-3 mb-3" rounded>
            <v-list-item three-line>
              <v-list-item-avatar size="55" color="#FFB74D">
                <p class="ma-2">FPPG</p>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="body-1">
                  222.51 FPPG
                </v-list-item-title>
                <div class="overline mb-2">Season FP: 4,005.10</div>

                <v-list-item-subtitle class="body-1 mb-1 mt-n1">
                  Team FPPG After 18 Weeks
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <!--card 1  -->

        <!--card 2  -->
        <v-col cols="12" md="4" sm="12">
          <v-card class="mx-auto mt-3 mb-3" rounded>
            <v-list-item three-line>
              <v-list-item-avatar size="55" color="#FFB74D">
                <p class="ma-2">NEXT</p>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="body-1">
                  {{ profile.teamName }}( {{ profile.key }})
                </v-list-item-title>
                <div class="overline mb-n2" style="vertical-align: middle">
                  Next Game:
                  <p class="green--text mt-n3" style="vertical-align: middle">
                    {{ profile.nextGame }}
                    <span style="vertical-align: middle">
                      Vs. {{ profile.oppName }}
                    </span>
                  </p>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <!-- card 2 -->
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SingleTeam",
  props: ["profile"],
  data() {
    return {
      panel: 0,
    };
  },
};
</script>

<style scoped></style>
